"use client";
import { FileRejection } from "react-dropzone";
import { enqueueSnackbar } from "notistack";
import { ApiConstant, AppConstant } from "@/const";
import { isClient } from "./api.utils";
import { toggleAppProgress } from "./common.utils";

export const handleRejectedUploadFiles = (
  FileRejection: FileRejection[],
  maxSize: number
) => {
  const fileUploadError = FileRejection[0];
  const maxSizeMb = maxSize / 1024 / 1024;
  if (
    fileUploadError.errors[0].code ===
    ApiConstant.DROPZONE_ERROR_CODE.ERROR_MAX_SIZE
  ) {
    enqueueSnackbar({
      variant: AppConstant.ERROR_VARIANT,
      message: `File ${fileUploadError.file.name} vượt quá ${maxSizeMb}MB!`,
    });
  } else if (
    fileUploadError.errors[0].code ===
    ApiConstant.DROPZONE_ERROR_CODE.ERROR_INVALID_TYPE
  ) {
    enqueueSnackbar({
      variant: AppConstant.ERROR_VARIANT,
      message: `File ${fileUploadError.file.name} không đúng định dạng!`,
    });
  } else if (
    fileUploadError.errors[0].code ===
    ApiConstant.DROPZONE_ERROR_CODE.ERROR_TOO_MANY_FILES
  ) {
    enqueueSnackbar({
      variant: AppConstant.ERROR_VARIANT,
      message: `Bạn tải vượt quá số lượng file cho phép`,
    });
  } else {
    enqueueSnackbar({
      variant: AppConstant.ERROR_VARIANT,
      message: fileUploadError.errors[0].message,
    });
  }
};
export const showLoading = () => {
  if (isClient()) {
    toggleAppProgress(true);
  }
};

export const hideLoading = () => {
  if (isClient()) {
    toggleAppProgress(false);
  }
};
export const downloadFileContentBase64 = (
  fileName: string,
  fileContent: string
) => {
  // Decode the base64 file content
  const byteCharacters = atob(fileContent);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the byte array
  const blob = new Blob([byteArray], { type: "application/json" });

  // Create a link element
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;

  // Programmatically trigger the download
  link.click();

  // Cleanup
  URL.revokeObjectURL(link.href);
};
